/**
 * desk-open@v1 — thin open (+ draft) SO/PO list rows for local desk lists — plan/33.
 */
import { matchesDeliverAxisFilter, matchesDueFilter, matchesLifecycleFilter, matchesPayAxisFilter, matchesReceiveAxisFilter, primaryDueBadge, } from "./due.js";
import { matchesOrderListQuery } from "./order-list.js";
export const DESK_OPEN_CHANNEL = "desk-open@v1";
/** Local desk list when lifecycle is open/draft/done and no server-only filters. */
export function deskOpenUsesLocalCache(opts) {
    if (opts.tagId)
        return false;
    if (opts.assignee && opts.assignee !== "all")
        return false;
    return (opts.lifecycle === "open" ||
        opts.lifecycle === "draft" ||
        opts.lifecycle === "done");
}
export function filterDeskOpenSalesOrders(rows, filters) {
    const q = filters.q ?? "";
    const pay = filters.pay ?? "all";
    const deliver = filters.deliver ?? "all";
    const due = filters.due ?? "all";
    return rows.filter((o) => {
        if (o.deleted)
            return false;
        if (filters.partyId && o.customerId !== filters.partyId)
            return false;
        if (!matchesOrderListQuery(q, {
            number: o.number,
            partyName: o.customerName,
            externalRef: o.customerRef,
        })) {
            return false;
        }
        if (!matchesLifecycleFilter(o.lifecycle, filters.lifecycle, {
            pay: o.pay,
            deliver: o.deliver,
        })) {
            return false;
        }
        if (!matchesPayAxisFilter(o.pay, pay))
            return false;
        if (!matchesDeliverAxisFilter(o.deliver, deliver))
            return false;
        return matchesDueFilter(primaryDueBadge({ paymentDueOn: o.paymentDueOn, deliverBy: o.deliverBy }, { now: filters.now, timeZone: filters.timeZone }), due);
    });
}
export function filterDeskOpenPurchaseOrders(rows, filters) {
    const q = filters.q ?? "";
    const pay = filters.pay ?? "all";
    const receive = filters.receive ?? "all";
    const due = filters.due ?? "all";
    return rows.filter((o) => {
        if (o.deleted)
            return false;
        if (filters.partyId && o.supplierId !== filters.partyId)
            return false;
        if (!matchesOrderListQuery(q, {
            number: o.number,
            partyName: o.supplierName,
            externalRef: o.supplierRef,
        })) {
            return false;
        }
        if (!matchesLifecycleFilter(o.lifecycle, filters.lifecycle, {
            pay: o.pay,
            receive: o.receive,
        })) {
            return false;
        }
        if (!matchesPayAxisFilter(o.pay, pay))
            return false;
        if (!matchesReceiveAxisFilter(o.receive, receive))
            return false;
        return matchesDueFilter(primaryDueBadge({ paymentDueOn: o.paymentDueOn, expectedOn: o.expectedOn }, { now: filters.now, timeZone: filters.timeZone }), due);
    });
}
export function sortDeskOpenBy(rows, sort, sortDir, valueOf) {
    const dir = sortDir === "desc" ? -1 : 1;
    return [...rows].sort((a, b) => {
        const av = valueOf(a);
        const bv = valueOf(b);
        if (av < bv)
            return -1 * dir;
        if (av > bv)
            return 1 * dir;
        return 0;
    });
}
